module.exports = __webpack_public_path__ + "img/heitongguge.1f369336.jpg";